import { render } from "./RoomAgentLayout.vue?vue&type=template&id=2a0fd9f6&scoped=true"
import script from "./RoomAgentLayout.vue?vue&type=script&lang=js"
export * from "./RoomAgentLayout.vue?vue&type=script&lang=js"

import "./RoomAgentLayout.vue?vue&type=style&index=0&id=2a0fd9f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0fd9f6"]])

export default __exports__